import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { fetchCmsList, DEFAULT_SITE_SETTINGS } from './lib/cms';

import { Header } from './components/Header';
import { Footer } from './components/Footer';
import { ScrollToTop } from './components/ScrollToTop';

import { Home } from './pages/Home';
import { Services } from './pages/Services';
import { ServiceDetail } from './pages/ServiceDetail';
import { Prices } from './pages/Prices';
import { Products } from './pages/Products';
import { BlogIndex } from './pages/BlogIndex';
import { BlogDetail } from './pages/BlogDetail';
import { About } from './pages/About';
import { GalleryPage } from './pages/GalleryPage';
import { Contact } from './pages/Contact';
import { Terms } from './pages/Terms';
import { NotFound } from './pages/NotFound';
import { Forbidden } from './pages/Forbidden';

export function App() {
  const [settings, setSettings] = useState(DEFAULT_SITE_SETTINGS);

  useEffect(() => {
    async function loadSettings() {
      const data = await fetchCmsList('site_settings');
      if (data && data.length > 0) {
        setSettings({ ...DEFAULT_SITE_SETTINGS, ...data[0] });
      }
    }
    loadSettings();
  }, []);

  return (
    <div className="min-h-screen flex flex-col bg-sand-50 text-brand-950 font-sans selection:bg-brand-900 selection:text-white">
      <ScrollToTop />
      <Header settings={settings} />

      <main className="flex-grow">
        <Routes>
          {/* Primary Routes */}
          <Route path="/" element={<Home settings={settings} />} />
          
          {/* Services */}
          <Route path="/ydelser" element={<Services />} />
          <Route path="/ydelser/:slug" element={<ServiceDetail settings={settings} />} />
          <Route path="/behandlinger" element={<Navigate to="/ydelser" replace />} />
          <Route path="/behandlinger/:slug" element={<ServiceDetail settings={settings} />} />
          
          {/* Pricing & Subscription */}
          <Route path="/priser" element={<Prices settings={settings} />} />
          <Route path="/pris" element={<Prices settings={settings} />} />
          <Route path="/vaelg-abonnement-hos-den-glade-fodmand" element={<Prices settings={settings} />} />
          
          {/* Products & Creamer */}
          <Route path="/produkter" element={<Products settings={settings} />} />
          <Route path="/bestil-creamer" element={<Products settings={settings} />} />
          
          {/* Blog & Articles */}
          <Route path="/blog" element={<BlogIndex />} />
          <Route path="/blog/:slug" element={<BlogDetail settings={settings} />} />
          <Route path="/category/fodpleje-info" element={<BlogIndex />} />
          <Route path="/category/:category" element={<BlogIndex />} />
          <Route path="/tag/:tag" element={<BlogIndex />} />
          
          {/* WordPress Legacy Date Route Mapping (/:year/:month/:day/:slug) */}
          <Route path="/:year/:month/:day/:slug" element={<BlogDetail settings={settings} />} />
          
          {/* About Us */}
          <Route path="/om-os" element={<About settings={settings} />} />
          <Route path="/den-glade-fodmand" element={<About settings={settings} />} />
          
          {/* Gallery */}
          <Route path="/galleri" element={<GalleryPage />} />
          
          {/* Contact */}
          <Route path="/kontakt" element={<Contact settings={settings} />} />
          <Route path="/kontakt-den-glade-fodmand" element={<Contact settings={settings} />} />
          
          {/* Terms */}
          <Route path="/salgs-og-leveringsbetingelser" element={<Terms settings={settings} />} />
          
          {/* Error Pages */}
          <Route path="/403" element={<Forbidden />} />
          <Route path="/404" element={<NotFound />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>

      <Footer settings={settings} />
    </div>
  );
}

export default App;
